import { render, staticRenderFns } from "./CheckBoxField.vue?vue&type=template&id=fa2d57c2&scoped=true"
import script from "./CheckBoxField.vue?vue&type=script&lang=js"
export * from "./CheckBoxField.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxField.vue?vue&type=style&index=0&id=fa2d57c2&prod&scoped=true&lang=scss"
import style1 from "./CheckBoxField.vue?vue&type=style&index=1&id=fa2d57c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2d57c2",
  null
  
)

export default component.exports